angular
    .module('app')
    .component('gameBundles', {
        templateUrl: '/templates/pages/game-bundles/game-bundles.html',
        controller: 'GameBundlesController',
        controllerAs: 'vm',
    });